export const checkinEditDrawer = {
  header: {
    title: "Check-in-Daten bearbeiten",
    age: "Alter:",
    docNotRequiredMinor: "Dokument nicht erforderlich (minderjährig)",
    docOptionalMinorES: "Dokument optional (minderjährig in Spanien)",
    docOptionalMinorCO: "Dokument optional (unter 7 in Kolumbien)",
  },
  sections: {
    basicData: "Grunddaten",
    stayDates: "Aufenthaltsdaten",
    italyDoc: "Dokument und Geburtsland",
    doc: "Dokument und Staatsangehörigkeit",
  },
  fields: {
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    birthDate: "Geburtsdatum",
    sex: "Geschlecht",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Dokumentart",
    docNumber: "Dokumentnummer",
    supportNumber: "Trägernummer",
    nationality: "Staatsangehörigkeit",
  },
  placeholders: {
    select: "Auswählen",
    selectNationality: "Staatsangehörigkeit auswählen",
    searchCountry: "Land suchen...",
    selectCountry: "Land auswählen",
    docNumberExample: "z. B. AB1234567",
    docNumberGeneric: "DNI / NIE / Reisepass",
    required: "Pflichtfeld",
    optional: "Optional",
  },
  sex: {
    male: "Männlich",
    female: "Weiblich",
    preferNotToSay: "Keine Angabe",
    other: "Divers",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "Geburtsland",
    birthCountryHint: ": wird auch als Staatsangehörigkeit verwendet",
    issuePlaceLabel: "Ausstellungsort des Dokuments",
    issuePlaceHint: ": Land, in dem das Dokument ausgestellt wurde",
    alloggiatiCode: "Alloggiati-Code:",
    iso3Label: "ISO3:",
    minorNote:
      "Minderjährig: Dokumentart, Nummer und Ausstellungsort werden leer an Alloggiati Web übermittelt (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Dokument nach Alters- bzw. Länderregel optional. Sie können es trotzdem ausfüllen.",
  },
  docTypes: {
    it: {
      IDENT: "Ausweisdokument (IDENT)",
      IDELE: "Elektronisches Ausweisdokument (IDELE)",
      PASOR: "Gewöhnlicher Reisepass (PASOR)",
      PASSE: "Dienstpass (PASSE)",
      PASDI: "Diplomatenpass (PASDI)",
      PATEN: "Führerschein (PATEN)",
      PATNA: "Bootsführerschein (PATNA)",
      CIDIP: "Diplomatenausweis (CIDIP)",
      RIFUG: "Reiseausweis für Flüchtlinge (RIFUG)",
    },
    co: {
      CC: "Bürgerausweis",
      CE: "Ausländerausweis",
      P: "Reisepass",
      PPT: "Vorübergehende Schutzerlaubnis",
      PEP: "Besondere Aufenthaltserlaubnis",
      DE: "Ausländisches Dokument",
      CD: "Diplomatenausweis",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Reisepass",
      OTRO: "Sonstiges",
    },
    generic: {
      ID: "Ausweisdokument",
      P: "Reisepass",
      OTRO: "Sonstiges",
    },
  },
  footer: {
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Wird gespeichert...",
  },
  errors: {
    nameRequired: "Vor- und Nachname sind erforderlich.",
    emailInvalid: "Ungültige E-Mail.",
    phoneRequired: "Telefonnummer ist erforderlich.",
    birthDateRequired: "Geburtsdatum ist erforderlich.",
    sexRequired: "Geschlecht ist erforderlich.",
    stayDatesRequired: "Aufenthaltsdaten sind erforderlich.",
    checkoutBeforeCheckin: "Das Check-out-Datum darf nicht vor dem Check-in-Datum liegen.",
    birthCountryRequired: "Geburtsland ist erforderlich.",
    docTypeRequired: "Dokumentart ist erforderlich.",
    docNumberRequired: "Dokumentnummer ist erforderlich.",
    issuePlaceRequired: "Ausstellungsort des Dokuments ist erforderlich.",
    nationalityRequired: "Staatsangehörigkeit ist erforderlich.",
    supportNumberRequired:
      "Bei spanischer Staatsangehörigkeit (volljährig) ist die Trägernummer erforderlich.",
    saveFailed: "Speichern nicht möglich.",
    saveError: "Fehler beim Speichern der Änderungen.",
  },
  toast: {
    saved: "Check-in erfolgreich aktualisiert",
  },
};
